import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { Provider } from 'react-redux';
import {store} from './store';
import { MantineProvider } from "@mantine/core";
import '@mantine/core/styles.css';

const root = ReactDOM.createRoot(document.getElementById('root'))

// pk_test_51N9pi8GwYlRApJ0w8Lz2o0lVKIUqAAd4S2LPB5mY2GHu2K2CWtYqbYBNgCayxu5iTygzw2iyS5mJVHhSM6IfGDJZ00mtIuhi5H
// pk_live_51N9pi8GwYlRApJ0wG7yS3NQboZU7cUlBAHxUnolT1UsEeqy4iyMPcmNBs2cgp8o70mN7EPzQkCAdMNhkR5YlXLjH006aOplm1v
const stripePromise = loadStripe(
  'pk_live_51N9pi8GwYlRApJ0wG7yS3NQboZU7cUlBAHxUnolT1UsEeqy4iyMPcmNBs2cgp8o70mN7EPzQkCAdMNhkR5YlXLjH006aOplm1v'
)
root.render(
  <React.StrictMode>
      <MantineProvider>
     <Provider store={store}>
        <Elements stripe={stripePromise}>
          <App />
        </Elements>
    </Provider>
    </MantineProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
